import { ReactNode } from 'react';
import { mojTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mojTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
